export class PortalWorkflowUser {
    userName = "";
    lastName = "";
    firstName = "";
    folderId = 0;
    personellNumber = "";
    zeitwirtschaft = false;
    eMail = "";
    eMailPortal = "";
    superiorUserName = "";
    userDefinedSubstituteUserName = "";
}